import { h } from "preact";
import { monogramSummary } from "../monogram/monogramTypeConfig";

export default function MonogramTriggerContent({
  added,
  value,
  onEdit,
  onRemove,
  editRef,
}) {
  return (
    <div className="monogram-trigger__content">
      <div className="monogram-trigger__content-inner">
        <div className="monogram-trigger__details">
          <div className="monogram-trigger__summary">
            {monogramSummary(value)}
          </div>
          <div className="monogram-trigger__actions">
            <button
              type="button"
              className="monogram-trigger__action link link--x-small link--black"
              onClick={onEdit}
              ref={editRef}
              tabIndex={added ? 0 : -1}
              aria-hidden={!added}
            >
              {window.localeStrings.product.monogram_edit}
            </button>
            <button
              type="button"
              className="monogram-trigger__action link link--x-small link--black"
              onClick={onRemove}
              tabIndex={added ? 0 : -1}
              aria-hidden={!added}
            >
              {window.localeStrings.product.monogram_remove}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
